import type { PushEventRef } from '@/types/push-events'

export const PUSH_REFRESH_DEBOUNCE_MS = 1000

export function usePushRefresh(events: PushEventRef<unknown> | PushEventRef<unknown>[], refresh: () => void) {
  const sources = Array.isArray(events) ? events : [events]

  watchDebounced(sources, results => {
    if (results.some(result => result?.data))
      refresh()
  }, { debounce: PUSH_REFRESH_DEBOUNCE_MS })
}
